import {
  BrowserCacheLocation,
  InteractionType,
  IPublicClientApplication,
  PublicClientApplication
} from "@azure/msal-browser";
import {MsalInterceptorConfiguration} from "@azure/msal-angular";
import {OAuthSettings} from "./creds";


const isIE = window.navigator.userAgent.indexOf('MSIE ') > -1 || window.navigator.userAgent.indexOf('Trident/') > -1;
const MS_GRAPH_URL = 'https://graph.microsoft.com/v1.0/me';
const BC_URL = 'https://api.businesscentral.dynamics.com';

export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: OAuthSettings.appClientId,
      authority: OAuthSettings.authority,
      redirectUri: OAuthSettings.redirectUri,
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
      storeAuthStateInCookie: isIE,
    }
  });
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();
  protectedResourceMap.set(MS_GRAPH_URL, OAuthSettings.scopesGrapheMs);
  protectedResourceMap.set(BC_URL, OAuthSettings.scopesBc);
  return {
    interactionType: InteractionType.Popup,
    protectedResourceMap,
  };
}
